<template>
    <div class="train-item__icon">
        <i class="add-button__icon material-icons" @click="add">
            add
        </i>
    </div>
</template>

<script>
export default {
    methods: {
        add() {
            this.$router.push({ name: 'adduser' });
        }
    }
}
</script>

<style scoped lang="scss">
.train-item__icon{
    position: absolute;
    top: 1rem;
    right: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    background-color: $color-white;
    box-shadow: 0 0 0.625rem $color-gray;

    &:active{
        background-color: $color-gray;
    }
}

.add-button__icon {
    font-size: 2.5rem;
    cursor: pointer;
}
</style>
